// Коды статусов исполнительных надписей.
// Используются ТОЛЬКО для бизнес-проверок в коде (например `status === PROJECT` для режима редактирования).
// Лейблы и цвета — через `@/shared/config/statusDictionary` + `<StatusDot>`.
export const EnforcementInscriptionStatus = Object.freeze({
  PROJECT: "PROJECT",
  PENDING_REVIEW: "PENDING_REVIEW",
  REGISTERED: "REGISTERED",
  ADDING_HEIRS: "ADDING_HEIRS",
  AWAITING_PAYMENT: "AWAITING_PAYMENT",
  SIGNING: "SIGNING",
  SIGNED: "SIGNED",
  CERTIFICATE_ISSUED: "CERTIFICATE_ISSUED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
});
